import arrowDown from '~/assets/icons/arrow_down.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import {
	StyledBody,
	StyledContainer,
	StyledExpandButton,
	StyledHeadContainer,
} from './ExpandWindow.styled';

const ExpandWindow = ({
	title,
	expanded,
	toggleExpand,
	height,
	children,
}: {
	title: string;
	expanded: boolean;
	toggleExpand: () => void;
	height: number;
} & React.PropsWithChildren) => {
	const handleToggle = () => {
		toggleExpand();
		playSound(Sound.ClickButton);
	};

	const handleMouseEnter = () => playSound(Sound.LinkCursor);

	return (
		<StyledContainer
			$expanded={expanded}
			$height={height}
			onClick={!expanded ? handleToggle : undefined}
			onMouseEnter={!expanded ? handleMouseEnter : undefined}
		>
			<StyledHeadContainer
				$expanded={expanded}
				onClick={expanded ? handleToggle : undefined}
				onMouseEnter={expanded ? handleMouseEnter : undefined}
			>
				<Text>{title}</Text>
				<StyledExpandButton>
					<img src={arrowDown} />
				</StyledExpandButton>
			</StyledHeadContainer>
			<StyledBody>
				<Divider
					$direction={'H'}
					style={{ marginBottom: 16, opacity: expanded ? 0.1 : 0 }}
				/>
				<div>{children}</div>
			</StyledBody>
		</StyledContainer>
	);
};

export { ExpandWindow };
